var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"components-rating"},[_c('Stars',{attrs:{"rating":_vm.ratingValue}}),_c('span',[_vm._v(_vm._s(_vm.executionsText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }